<div #main class="main__layout">
  <div #navbar class="main__navbar">
    <app-user-navbar></app-user-navbar>
  </div>

  <div #root class="main__content">
    <div class="my-5">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
